// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2u2Lf","fileBtn":"File_fileBtn__mMjr4","closeBtn":"File_closeBtn__1sEhm","fileSelected":"File_fileSelected__vfolF","disabled":"File_disabled__20Zrq"};